import { styled } from 'styled-components'

export const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 342px;
`
